// cordova-singular-sdk.service.ts

import { SingularSdkInterface } from '../interface/singular-sdk.interface';

declare var cordova: any;

export class CordovaSingularSdk implements SingularSdkInterface {

  constructor(
    private apiKey: string,
    private secretKey: string,
    private appPackageName: string,
    private persistentId: string
  ) {}

  init(): void {
    try {
      const singularConfig = new cordova.plugins.SingularCordovaSdk.SingularConfig(
        this.apiKey,
        this.secretKey
      );
      singularConfig.withSkAdNetworkEnabled(true);
      cordova.plugins.SingularCordovaSdk.init(singularConfig);
      console.info('SDK Cordova de Singular inicializado exitosamente.');
    } catch (error) {
      console.error('Error al inicializar el SDK Cordova de Singular:', error);
      throw error;
    }
  }

  pageVisit(): void {
    cordova.plugins.SingularCordovaSdk.pageVisit();
  }

  login(cognitoUser: string): void {
    cordova.plugins.SingularCordovaSdk.setCustomUserId(cognitoUser);
  }

  logout(): void {
    cordova.plugins.SingularCordovaSdk.unsetCustomUserId();
  }

  sendEvent(eventName: string, args?: any): void {
    cordova.plugins.SingularCordovaSdk.eventWithArgs(eventName, args);
  }

  revenue(itemName: string, currency: string, amount: number, args?: any): void {
    cordova.plugins.SingularCordovaSdk.customRevenueWithArgs(itemName, currency, amount, args);
  }

  getDeviceDefaultID(): string {
    return cordova.plugins.SingularCordovaSdk.getSingularDeviceId() || '';
  }

  browserDeviceID(): string {
    return cordova.plugins.SingularCordovaSdk.getBrowserDeviceId() || 'NA';
  }
}
